<template>
  <SettingsPageContractView v-if="contract" :contract="contract" />
</template>

<script setup lang="ts">
import { computed } from 'vue'
import { useSettingsPageContractViewFetcherQuery } from './SettingsPageContractViewFetcher.generated'
import SettingsPageContractView from './SettingsPageContractView.vue'

const { result } = useSettingsPageContractViewFetcherQuery()
const contract = computed(() => result.value?.contract)
</script>
